/* eslint-disable */

export function humanFilesize(sizeInBytes, spacer = ' ') {
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let l = 0, n = parseInt(sizeInBytes, 10) || 0;
    while(n >= 1024 && ++l) {
        n = n/1024;
    }

    return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + spacer + units[l]);
}

export function nearestMB(sizeInBytes) {
    if (sizeInBytes <= 0) {
        return 'zero bytes';
    }

    const nearestKB = Math.ceil(sizeInBytes / 1024);
    const nearestMB = Math.ceil(nearestKB / 1024);

    switch (true) {
        case nearestMB <= 1:
            return '1 MB or less';
        case nearestMB <= 2:
            return '1-2 MB';
        case nearestMB <= 3:
            return '2-3 MB';
        case nearestMB <= 5:
            return '3-5 MB';
        case nearestMB <= 10:
            return '5-10 MB';
        case nearestMB <= 15:
            return '10-15 MB';
        case nearestMB <= 20:
            return '15-20 MB';
        case nearestMB <= 25:
            return '20-25 MB';
        case nearestMB <= 30:
            return '25-30 MB';
        case nearestMB < 50:
            return '30-50 MB';
    }
    return '50 MB or more';
}

/**
 * This is very basic but can be reused in the app, and
 * improved on later if required.
 */
export function extractExtension(filename, noExtensionFallback = null) {
    if (!filename.includes('.')) {
        return noExtensionFallback;
    }

    return filename.split('.').pop();
}
